import axios from 'axios'
import { getCookieValue } from '../common-services'
import { BASE_URL } from './../../config'


export const getAllTemplates = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCCoScholasticAreaAPI.php?Client_Type=NOCHECK&get_data=get_template&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all report card templates', err.message) // Handle errors
  }
}
export const createTemplate = async (templateName) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCCreateMarksTemplate1.php?template_name=${templateName}&template_sender_new=1&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting creating report card templates', err.message) // Handle errors
  }
}
export const updateTemplate = async (templateId, templateName) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCCreateMarksTemplate1.php?template_name=${templateName}&template_update_new=1&Template_Id=${templateId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting updating report card templates', err.message) // Handle errors
  }
}
export const disableTemplate = async (templateId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCCreateMarksTemplate1.php?template_disable_new=1&template_id=${templateId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting disbaling report card templates', err.message) // Handle errors
  }
}
export const getAllStreams = async (templateId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/api-controller/getCommonData.php?getStreams=1&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all streams', err.message) // Handle errors
  }
}
export const getMappedClassTemplates = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateClassMap1.php?get_template_class_mappings=1&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all class template mapped', err.message) // Handle errors
  }
}
export const getMappedClassTemplatesByTCMLId = async (templateId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateClassMap1.php?get_template_class_mapping_by_id=1&tcml_id=${templateId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all class template mapped by template id', err.message) // Handle errors
  }
}
export const createClassTemplateMapping = async (template, studclassToApply, stream) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateClassMap1.php?template_sender_new=1&schoolCode=${schoolCode}&loginId=${loginId}&template=${template}&studclassToApply=${studclassToApply}&stream=${stream}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while creating class template mapping', err.message) // Handle errors
  }
}
export const updateClassTemplateMapping = async (template, studclassToApply, stream, TCML_ID) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateClassMap1.php?template_update_new=1&schoolCode=${schoolCode}&loginId=${loginId}&template=${template}&studclassToApply=${studclassToApply}&stream=${stream}&TCML_ID=${TCML_ID}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while updating class template mapping', err.message) // Handle errors
  }
}
export const disableClassTemplateMapping = async (TCML_ID) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateClassMap1.php?template_disable_new=1&schoolCode=${schoolCode}&loginId=${loginId}&tcml_id=${TCML_ID}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while disbaling class template mapping', err.message) // Handle errors
  }
}

export const getRCCombinedTerms = async (template, Session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCCoScholasticTermApi.php?Client_Type=NOCHECK&get_data=get_term&template=${template}&Session=${Session}&schoolCode=${schoolCode}&loginid=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while disbaling class template mapping', err.message) // Handle errors
  }
}

export const getSubjects = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/api-controller/getCommonData.php?getSubjects=1&schoolCode=${schoolCode}&loginid=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting subjects', err.message) // Handle errors
  }
}
export const insertNewSubject = async (
  class_name,
  school_session,
  subject_name,
  sub_subject_name,
  subject_type,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateSubList1.php?sub_list_sender=&action=add_sub_list&class_name=${class_name}&school_session=${school_session}&subject_name=${subject_name}&sub_subject_name=${sub_subject_name}&subject_type=${subject_type}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while inserting new subject', err.message) // Handle errors
  }
}
export const updateSubjectData = async (
  class_name,
  school_session,
  subject_name,
  sub_subject_name,
  subject_type,
  sub_list_id,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateSubList1.php?sub_list_sender=&action=update_sub_list&class_name=${class_name}&school_session=${school_session}&subject_name=${subject_name}&sub_list_id=${sub_list_id}&sub_subject_name=${sub_subject_name}&subject_type=${subject_type}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while updating subject', err.message) // Handle errors
  }
}
export const subjectsByClassAndSession = async (class_id, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateSubList1.php?Client_Type=NOCHECK&get_sub_list_details_new=1&class_id=${class_id}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting subjets by class and session', err.message) // Handle errors
  }
}
export const onSubjectGroupChange = async (TSL_Id, grp_name) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateSubList1.php?Client_Type=NOCHECK&update_list=change_subject_group&list_id=${TSL_Id}&subject_group=${grp_name}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while changing subject group', err.message) // Handle errors
  }
}
export const getTermsByClassSession = async (class_id, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateSubList1.php?Client_Type=NOCHECK&Get_Terms=1&class_id=${class_id}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting all terms by class and session', err.message) // Handle errors
  }
}
export const mapTermAndSubject = async (session, class_id, term_id, subject_id, sub_subject_id) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateSubList1.php?map_subject_term=1&action=map&session=${session}&class_id=${class_id}&term_id=${term_id}&subject_id=${subject_id}&sub_subject_id=${sub_subject_id}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while mapping term and subject', err.message) // Handle errors
  }
}
export const unMapTermAndSubject = async (
  session,
  class_id,
  term_id,
  subject_id,
  sub_subject_id,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateSubList1.php?map_subject_term=1&action=unmap&session=${session}&class_id=${class_id}&term_id=${term_id}&subject_id=${subject_id}&sub_subject_id=${sub_subject_id}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while mapping term and subject', err.message) // Handle errors
  }
}
export const copySubjects = async (
  From_session,
  To_session,
  From_Template_Class,
  To_Template_Class,
) => {
  console.log(From_session, To_session, From_Template_Class, To_Template_Class)
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateSubList1.php?copy_subjects_new=1&From_session=${From_session}&To_session=${To_session}&From_Template_Class=${From_Template_Class}&To_Template_Class=${To_Template_Class}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while mapping term and subject', err.message) // Handle errors
  }
}

export const getDetailsOptions = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/SelectDataApi.php?get_rc_student_details_types=1&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting all details options', err.message) // Handle errors
  }
}

// report config routes
export const getReportConfigFormData = async (session, template, rc_type) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCConfiguration1.php?Client_Type=NOCHECK&get_edit_data=configuration&session=${session}&template=${template}&rc_type=${rc_type}&schoolCode=${schoolCode}&loginId=${loginId}
`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting all details options', err.message) // Handle errors
  }
}
export const getConfigFormSubList = async (session, template, subject_display) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCConfiguration1.php?Client_Type=NOCHECK&get_sub_list=get_details&template_id=${template}&session=${session}&subject_display=${subject_display}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting all details options', err.message) // Handle errors
  }
}

// student report page routes
export const getTermNamesByClasSecSession = async (session, Class_Id, Section_Id) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCReportCardApis.php?Client_Type=NOCHECK&get_data=get_term_name&Class_Id=${Class_Id}&Section_Id=${Section_Id}&Session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting all details options', err.message) // Handle errors
  }
}
export const getExamsByTerm = async (TTL_Id) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCReportCardApis.php?Client_Type=NOCHECK&get_data=get_exam_name&TTL_Id=${TTL_Id}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting all exams options', err.message) // Handle errors
  }
}
export const getClassesByTemplate = async (template) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCSchoolResultAnalysis1.php?Client_Type=NOCHECK&get_data=get_class&template=${template}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting all exams options', err.message) // Handle errors
  }
}
export const submitStudentAnalysisReport = async (formValues) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  const formData = new FormData()
  Object.entries(formValues).forEach(([key, value]) => {
    formData.append(key, value)
  })
  formData.append('schoolCode', schoolCode)
  formData.append('loginId', loginId)

  try {
    return await axios.post(`${BASE_URL}/RCExamAnalysis.php`, formData) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting student analytic reports', err.message) // Handle errors
  }
}
export const getSubjectByClassAndStream = async (class_id, stream, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCSchoolResultAnalysis1.php?Client_Type=NOCHECK&get_data=get_subject&Class_Id=${class_id}&Stream=${stream}&Session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting student analytic reports', err.message) // Handle errors
  }
}
export const processClassSectionMarks = async (formValue) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  const querryString = Object.entries(formValue)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&')
  try {
    return await axios.get(
      `${BASE_URL}/RCSchoolResultAnalysis1.php?template_sender=&${querryString}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting student analytic reports', err.message) // Handle errors
  }
}
export const getTermTemplates = async (Session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTermExamList1.php?get_term_template_by_session=1&Session=${Session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting student analytic reports', err.message) // Handle errors
  }
}
export const getExamLevels = async (Session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTermExamList1.php?Client_Type=NOCHECK&get_levels=1&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting student analytic reports', err.message) // Handle errors
  }
}
export const getSubjectDetailsForInsert = async (term_id, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTermExamList1.php?Client_Type=NOCHECK&get_exam_subject_form_new=1&term_id=${term_id}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting subject list', err.message) // Handle errors
  }
}
export const getSubjectDetailsForGrid = async (TTL_Id) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCReportCardApis.php?Client_Type=NOCHECK&get_data=get_exam_name&TTL_Id=${TTL_Id}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting subject grid', err.message) // Handle errors
  }
}
export const getExamDetailsById = async (exam_id, term_id, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTermExamList1.php?Client_Type=NOCHECK&get_exam_subject_grid_new=1&exam_id=${exam_id}&term_id=${term_id}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting subject grid', err.message) // Handle errors
  }
}

export const addNewExam = async (querryString) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTermExamList1.php?template_sender_new=1&${querryString}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while adding new exam', err.message) // Handle errors
  }
}
export const updateExam = async (querryString) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCEditTermExamList1.php?edit_form_new=1&${querryString}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while updating exam', err.message) // Handle errors
  }
}
export const copyExams = async (From_Term, To_Term, From_session, To_session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTermExamList1.php?Client_Type=NOCHECK&copy_exams_new=1&From_Term=${From_Term}&To_Term=${To_Term}&From_session=${From_session}&To_session=${To_session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while copying exam', err.message) // Handle errors
  }
}

// sub subject marking page apis
export const getTermByTemplateAndSession = async (template, Session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCCoScholasticTermAPI.php?Client_Type=NOCHECK&get_data=get_term&template=${template}&Session=${Session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while copying exam', err.message) // Handle errors
  }
}
export const getSubSubjects = async (class_id, subject, stream, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCGroupSubjectMarksConfig1.php?Client_Type=NOCHECK&get_data=get_sub_subjects&class_id=${class_id}&subject=${subject}&stream=${stream}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting sub subjects', err.message) // Handle errors
  }
}
export const getClassesInSubSubject = async (template) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCGroupSubjectMarksConfig1.php?Client_Type=NOCHECK&get_data=get_class&template=${template}&schoolCode=${schoolCode}&loginId=${loginId}
`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while classes sub subjects', err.message) // Handle errors
  }
}
export const getSubjectsInSubSubject = async (Class_Id, Session, Stream) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCGroupSubjectMarksConfig1.php?Client_Type=NOCHECK&get_data=get_subject&Class_Id=${Class_Id}&Session=${Session}&Stream=${Stream}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while classes sub subjects', err.message) // Handle errors
  }
}
export const getSubSubjectExamNames = async (
  TTL_Id,
  class_id,
  subject,
  sub_subjects,
  session,
  stream,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCGroupSubjectMarksConfig1.php?Client_Type=NOCHECK&get_exam_name_new=1&TTL_Id=${TTL_Id}&class_id=${class_id}&subject=${subject}&sub_subjects=${sub_subjects}&session=${session}&stream=${stream}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting sub subjects', err.message) // Handle errors
  }
}
export const submitSubSubjectMarks = async (dataString) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  const formData = new FormData()
  formData.append('updatemarks', dataString)
  try {
    return await axios.post(
      `${BASE_URL}/RCGroupSubjectMarksConfig1.php?save_student_marks=save&schoolCode=${schoolCode}&loginId=${loginId}`,
      formData,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while updating subject marks', err.message) // Handle errors
  }
}

// api for add subject ui
export const onAddInTotalFlagChangeStatus = async (list_id, change_status_flag) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateSubList1.php?Client_Type=NOCHECK&update_list=change_status_display_subject&list_id=${list_id}&change_status_flag=${change_status_flag}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting sub subjects', err.message) // Handle errors
  }
}
// mandatory suibject page apis
export const getMandatorySubjects = async (class_id, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateSubList1.php?Client_Type=NOCHECK&get_sub_list=get_mandatory_details&class_id=${class_id}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting mandatory subjects', err.message) // Handle errors
  }
}
export const allocateMandatorySubjects = async (session, template_master_id) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateSubList1.php?insert_student_subject_mandatory_new=1&school_session=${session}&template_master_id=${template_master_id}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting mandatory subjects', err.message) // Handle errors
  }
}

// add subject priority apis
export const getSubjectPriorityList = async (class_id, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateSubList1.php?Client_Type=NOCHECK&get_sub_list_details_new=1&class_id=${class_id}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting mandatory subjects', err.message) // Handle errors
  }
}
export const saveSubjectPriority = async (queryString, TCML_ID, school_session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateSubList1.php?save_subject_priority=1&TCML_ID=${TCML_ID}&template_sender=&school_session=${school_session}${queryString}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while saving subject priorities', err.message) // Handle errors
  }
}

// add optional subjects apis
export const getSectionByClassAndStream = async (classId, stream) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateSubList1.php?getSectionsAllOfStreamNew=1&classId=${classId}&stream=${stream}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting sections by class and stream', err.message) // Handle errors
  }
}
export const getOptionslSubjects = async (class_id, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateSubList1.php?getAllSubjectsNew=1&class_id=${class_id}&session=${session}&type=Optional&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting optional subjects', err.message) // Handle errors
  }
}
export const getStudentList = async (tcml_id, class_id, session, section, sub_subject_name) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateSubList1.php?Client_Type=NOCHECK&get_students_list_details_new=1&tcml_id=${tcml_id}&class_id=${class_id}&session=${session}&section=${section}&sub_subject_name=${sub_subject_name}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting optional subjects', err.message) // Handle errors
  }
}
export const allocateSubjectsToStudent = async (queryString) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // formdata.append('schoolCode', schoolCode)
  // formdata.append('loginId', loginId)
  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateSubList1.php?insert_student_optional_subject_new=1&${queryString}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while allocating subjects', err.message) // Handle errors
  }
}

// student report card apis
export const getStudentsList = async (class_id, sec_id, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // formdata.append('schoolCode', schoolCode)
  // formdata.append('loginId', loginId)
  try {
    return await axios.get(
      `${BASE_URL}/RCGenerate1.php?Client_Type=NOCHECK&get_all_students_by_class_section=1&class_id=${class_id}&sec_id=${sec_id}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting student lis', err.message) // Handle errors
  }
}

// class report card apis
export const getTermCombinationByClassSection = async (class_id, sec_id, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // formdata.append('schoolCode', schoolCode)
  // formdata.append('loginId', loginId)
  try {
    return await axios.get(
      `${BASE_URL}/RCReportCardApis.php?Client_Type=NOCHECK&get_data=get_term_combinations_by_class_stream&Class_Id=${class_id}&Section_Id=${sec_id}&Session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting getTermCombinationByClassSection', err.message) // Handle errors
  }
}

export const getRCExams = async (ttl_id) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/RCReportCardApis.php?Client_Type=NOCHECK&get_data=get_exam_name&TTL_Id=${ttl_id}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting rcexams', err.message) // Handle errors
  }
}

export const addRCLockConfig = async (session, template, term, exam, month, status) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // https://stage9.swiftcampus.com/RCLockConfig1.php?session=2024-2025&template_sender_new=1&template=3&term=22&exam=88&month=4&config_status=1
  try {
    return await axios.get(
      `${BASE_URL}/RCLockConfig1.php?session=${session}&template_sender_new=1&template=${template}&term=${term}&exam=${exam}&month=${month}&config_status=${status}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while inserting Rc locking ', err.message) // Handle errors
  }
}

export const getConfigByTemplate = async (session, template) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // https://stage9.swiftcampus.com/RClockConfig1.php?Client_Type=NOCHECK&table_body_new=1&template=2&Session=2024-2025
  try {
    return await axios.get(
      `${BASE_URL}/RClockConfig1.php?Client_Type=NOCHECK&table_body_new=1&template=${template}&Session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Rc locking Table', err.message) // Handle errors
  }
}

export const uploadsignatureImage = async (classId, secId, uploadImage) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  const formData = new FormData()
  formData.append('submit_form', '1')
  formData.append('s_class', classId)
  formData.append('class_section', secId)
  formData.append('teacher_signature', uploadImage)
  formData.append('loginid', loginId)
  formData.append('schoolCode', schoolCode)

  try {
    return await axios.post(
      `${BASE_URL}/RCClassTeachers_Images1.php`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
  } catch (err) {
    console.log('Error while uploading RC class teacher signature:', err.message)
  }
}

export const getTermsByClassSecIdSession = async (classId, secId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // https://stage9.swiftcampus.com//RCReportCardApis.php?Client_Type=NOCHECK&get_data=get_term_name&Class_Id=10&Section_Id=19&loginid=swipetouch&Session=2024-2025
  try {
    return await axios.get(
      `${BASE_URL}//RCReportCardApis.php?Client_Type=NOCHECK&get_data=get_term_name&Class_Id=${classId}&Section_Id=${secId}&Session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Terms', err.message) // Handle errors
  }
}

export const getMarksEntryLockingDetails = async (classId, secId, session, exam) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //https://stage9.swiftcampus.com/RCMarksEntryLocking1.php?Client_Type=NOCHECK&get_data=get_subject&Class_Id=10&Section_Id=20&Session=2024-2025&exam_name=32&loginid=swipetouch
  try {
    return await axios.get(
      `${BASE_URL}/RCMarksEntryLocking1.php?Client_Type=NOCHECK&get_data=get_subject&Class_Id=${classId}&Section_Id=${secId}&Session=${session}&exam_name=${exam}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Marks Entry locking Table', err.message) // Handle errors
  }
}

export const changeLockStatus = async (classId, secId, subjectId, session, telId, lockStatus) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // http://localhost//stageD/RCMarksEntryLocking1.php?Client_Type=NOCHECK&change_lock_status=1&Class_Id=11&Section_Id=21&Subject_Id=1&Session=2024-2025&TEL_Id=52&lock_status=1&loginid=swipetouch
  try {
    return await axios.get(
      `${BASE_URL}/RCMarksEntryLocking1.php?Client_Type=NOCHECK&change_lock_status=1&Class_Id=${classId}&Section_Id=${secId}&Subject_Id=${subjectId}&Session=${session}&TEL_Id=${telId}&lock_status=${lockStatus}&&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while marking  locking Status', err.message) // Handle errors
  }
}

export const strucutureCopy = async (session1, session2) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // http://localhost//stageD/RCStructureCopy1.php?copy=template_structures&From_session=2024-2025&To_session=2024-2025
  try {
    return await axios.get(
      `${BASE_URL}/RCStructureCopy1.php?copy=template_structures&From_session=${session1}&To_session=${session2}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while Copying Structure', err.message) // Handle errors
  }
}

export const getRcStructureSubjects = async (template, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //https://stage9.swiftcampus.com/RCStructureDelete1.php?Client_Type=NOCHECK&get_data=get_subject&Template_Id=2&loginid=swipetouch&Session=2024-2025
  try {
    return await axios.get(
      `${BASE_URL}/RCStructureDelete1.php?Client_Type=NOCHECK&get_data=get_subject&Template_Id=${template}&Session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting rc strcuture subjects', err.message) // Handle errors
  }
}
export const rcStructureDelete = async (session, template, structureType, term, exam, subject) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //https://stage9.swiftcampus.com/RCStructureDelete1.php?Client_Type=NOCHECK&get_data=get_subject&Template_Id=2&loginid=swipetouch&Session=2024-2025
  try {
    return await axios.get(
      `${BASE_URL}/RCStructureDelete1.php?delete_structure=1&session=${session}&template=${template}&structure_type=${structureType}&term=${term}&exam=${exam}&subject=${subject}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while Deleting rc strucuture', err.message) // Handle errors
  }
}

export const getUnlockReportCardTable = async (session, classId, secId, term) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //https://stage9.swiftcampus.com/RCStudentWisePDFLocking1.php?Client_Type=NOCHECK&get_student_by_class_session=get_list&school_id=1&school_session=2024-2025&class_id=10&class_sec_id=19&term=11
  try {
    return await axios.get(
      `${BASE_URL}/RCStudentWisePDFLocking1.php?Client_Type=NOCHECK&get_student_by_class_session=get_list&school_id=1&school_session=${session}&class_id=${classId}&class_sec_id=${secId}&term=${term}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting unlock report table', err.message) // Handle errors
  }
}

//stage9.swiftcampus.com/RCStudentWisePDFLocking1.php?allow_student_rc=allow_stu&student_id=6114&stud_session=2024-2025&term=11&Is_Block=0

export const togglePdfBlocking = async (studentId, session, term, isBlock) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //https://stage9.swiftcampus.com/RCStudentWisePDFLocking1.php?allow_student_rc=allow_stu&student_id=6114&stud_session=2024-2025&term=11&Is_Block=0
  try {
    return await axios.get(
      `${BASE_URL}//RCStudentWisePDFLocking1.php?block_student_rc_new=1&student_id=${studentId}&stud_session=${session}&term=${term}&Is_Block=${isBlock}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while toggling pdf', err.message) // Handle errors
  }
}

export const getDateConfigTable = async (template, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //https://stage9.swiftcampus.com/RCMarksEntryDateConfig1.php?Client_Type=NOCHECK&table_body_new=1&template=2&session=2024-2025
  try {
    return await axios.get(
      `${BASE_URL}/RCMarksEntryDateConfig1.php?Client_Type=NOCHECK&table_body_new=1&template=${template}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting data config table', err.message) // Handle errors
  }
}

export const addDateConfig = async (session, template, term, exam, date) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //https://stage9.swiftcampus.com/RCMarksEntryDateConfig1.php?session=2024-2025&template=2&template_sender=&term=20&exam=85&last_date=15%2F05%2F2025
  try {
    return await axios.get(
      `${BASE_URL}/RCMarksEntryDateConfig1.php?session=${session}&template=${template}&template_sender=1&term=${term}&exam=${exam}&last_date=${date}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while adding date config', err.message) // Handle errors
  }
}

export const addMarksConverted = async (
  session,
  template,
  stream,
  term,
  exam,
  classId,
  subject,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //https://stage9.swiftcampus.com/RCProcessObtExamMarks1.php?session=2024-2025&template=3&template_sender=&template_stream=GENERAL&term_id=19&exam_id=84&class_id=3&subject_id=22
  try {
    return await axios.get(
      `${BASE_URL}/RCProcessObtExamMarks1.php?session=${session}&template=${template}&template_sender=1&template_stream=${stream}&term_id=${term}&exam_id=${exam}&class_id=${classId}&subject_id=${subject}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while adding marks convert', err.message) // Handle errors
  }
}

export const submitGroupSubjectMarks = async (
  session,
  template,
  stream,
  classId,
  term,
  subject,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //https://stage9.swiftcampus.com/RCProcessGrpSubjectMarks1.php?session=2024-2025&template=9&template_sender=&template_stream=GENERAL&class_id=10&term=11&subject=2&Call_From=WEB
  try {
    return await axios.get(
      `${BASE_URL}/RCProcessGrpSubjectMarks1.php?session=${session}&template=${template}&template_sender=1&template_stream=${stream}&class_id=${classId}&term=${term}&subject=${subject}&Call_From=WEB&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while submitting group subject marks', err.message) // Handle errors
  }
}

export const getTermCombinatonByTemplate = async (template, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //https://stage9.swiftcampus.com/RCProcessTermMarks1.php?Client_Type=NOCHECK&get_term_combinations_by_template=1&template=3&Session=2024-2025&loginid=swipetouch

  try {
    return await axios.get(
      `${BASE_URL}/RCProcessTermMarks1.php?Client_Type=NOCHECK&get_term_combinations_by_template=1&template=${template}&Session=${session}&schoolCode=${schoolCode}&loginId=${loginId}
`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while Dgetting term combination by template', err.message) // Handle errors
  }
}

export const getExamsByTermCombId = async (termCombId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //https://stage9.swiftcampus.com/RCProcessTermMarks1.php?Client_Type=NOCHECK&get_exams=1&Term_Comb_Id=40&Session=2024-2025&loginid=swipetouch

  try {
    return await axios.get(
      `${BASE_URL}/RCProcessTermMarks1.php?Client_Type=NOCHECK&get_exams=1&Term_Comb_Id=${termCombId}&Session=${session}&schoolCode=${schoolCode}&loginId=${loginId}
`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting exam by term comb id', err.message) // Handle errors
  }
}

export const submitProcessTermMarks = async (
  session,
  template,
  stream,
  term,
  classId,
  subject,
  exam,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //http://localhost//stageD/RCProcessTermMarks1.php?session=2024-2025&template=2&template_sender=&template_stream=GENERAL&term_comb=36&class_id=3&subject=14&examids%5B%5D=84&process_type=both&loginid=swipetouch&Call_From=WEB

  try {
    return await axios.get(
      `${BASE_URL}/RCProcessTermMarks1.php?session=${session}&template=${template}&template_sender=1&template_stream=${stream}&term_comb=${term}&class_id=${classId}&subject=${subject}&examids[]=${exam}&process_type=both&schoolCode=${schoolCode}&loginId=${loginId}&Call_From=WEB
`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while Submitting Process Term Marks', err.message) // Handle errors
  }
}

export const submitReplicateMarks = async (
  session,
  template,
  stream,
  fromTerm,
  toTerm,
  fromExam,
  toExam,
  classId,
  subject,
  copyType,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //http://localhost//stageD/RCReplicateExamMarks1.php?session=2024-2025&template=2&template_sender=&template_stream=GENERAL&from_term_id=19&from_exam_id=84&to_term_id=20&to_exam_id=85&class_id=3&subject_id=22&copy_type=copy_and_convert&Call_From=WEB

  try {
    return await axios.get(
      `${BASE_URL}/RCReplicateExamMarks1.php?session=${session}&template=${template}&template_sender=1&template_stream=${stream}&from_term_id=${fromTerm}&from_exam_id=${fromExam}&to_term_id=${toTerm}&to_exam_id=${toExam}&class_id=${classId}&subject_id=${subject}&copy_type=${copyType}&Call_From=WEB&schoolCode=${schoolCode}&loginId=${loginId}
`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while Submitting REplicate MArks', err.message) // Handle errors
  }
}

export const submitProcessExamMarks = async (
  session,
  template,
  stream,
  fromTerm,
  fromExams,
  classId,
  subjects,
  formula,
  toTerm,
  toExam,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  const params = new URLSearchParams({
    session,
    template,
    template_sender: 1,
    template_stream: stream,
    from_term_id: fromTerm,
    class_id: classId,
    formula,
    to_term_id: toTerm,
    main_exam: toExam,
    Call_From: 'WEB',
    loginid: loginId,
  })

  // Append arrays with [] notation
  fromExams.forEach((exam) => params.append('sub_exams[]', exam))
  subjects.forEach((sub) => params.append('subjects[]', sub))

  try {
    return await axios.post(
      `${BASE_URL}/RCProcessSubExamMarks1.php?${params.toString()}&schoolCode=${schoolCode}&loginId=${loginId}`,
    )
  } catch (err) {
    console.log('Error while Submitting Process Marks', err.message)
  }
}

export const getSubSubjectByClassAndStream = async (class_id, stream, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCProcessSubExamMarks1.php?Client_Type=NOCHECK&get_data=get_subject&Class_Id=${class_id}&Stream=${stream}&Session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting student BY Class & Stream', err.message) // Handle errors
  }
}

export const getGroupedSubjectByClassAndStream = async (class_id, stream, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCProcessGrpSubjectMarks1.php?Client_Type=NOCHECK&get_data=get_subject&Class_Id=${class_id}&Stream=${stream}&Session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Grouped subjects by class & Stream', err.message) // Handle errors
  }
}

export const getGrades = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(`${BASE_URL}/SelectDataApi.php?get_grades=1&schoolCode=${schoolCode}&loginId=${loginId}`) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting grades', err.message) // Handle errors
  }
}

export const submitScholasticGrades = async (
  template,
  grade,
  lowerLimit,
  UpperLimit,
  gradeColor,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCGradeMaster1.php?template_sender=1&template_id=${template}&grade=${grade}&lower_limit=${lowerLimit}&upper_limit=${UpperLimit}&grade_color_rgb_value=${gradeColor}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting grades', err.message) // Handle errors
  }
}

export const getScholasticGradesByTemplate = async (template) => {
  // https://stage9.swiftcampus.com/RCGradeMaster1.php?Client_Type=NOCHECK&table_body_new=1&template_id=1
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/RCGradeMaster1.php?Client_Type=NOCHECK&table_body_new=1&template_id=${template}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting grades by template', err.message) // Handle errors
  }
}

//localhost//stageD/RCGradeMaster1.php?copy=template&From_Template=2&To_Template=2

export const copyGradeMasterTemplate = async (fromTemplate, toTemplate) => {
  // https://stage9.swiftcampus.com/RCGradeMaster1.php?copy=template&From_Template=2&To_Template=2
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.post(
      `${BASE_URL}/RCGradeMaster1.php?copy=template&From_Template=${fromTemplate}&To_Template=${toTemplate}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while Copying templates', err.message) // Handle errors
  }
}

export const editGradeMaster = async (
  template,
  gmtId,
  grade,
  lowerLimit,
  UpperLimit,
  gradeColor,
) => {
  // https://stage9.swiftcampus.com/RCEditGradeMaster1.php?template_id=2&template_sender=&GMT_Id=9&grade=A1&lower_limit=91&upper_limit=100&grade_color_rgb=%239b2291&grade_color_rgb_value=155%2334%23145
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  const url = `${BASE_URL}/RCEditGradeMaster1.php?template_sender=1&template_id=${template}&GMT_Id=${gmtId}&grade=${grade}&lower_limit=${lowerLimit}&upper_limit=${UpperLimit}&grade_color_rgb_value=${gradeColor}&schoolCode=${schoolCode}&loginId=${loginId}`

  console.log('Request URL:', url)

  try {
    return await axios.post(url) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while edit grade master', err.message) // Handle errors
  }
}

export const getScholasticDivisionsByTemplate = async (template) => {
  // https://stage9.swiftcampus.com/RCDivisionMaster1.php?Client_Type=NOCHECK&table_body=1&template_id=9
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/RCDivisionMaster1.php?Client_Type=NOCHECK&table_body_new=1&template_id=${template}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting division by template', err.message) // Handle errors
  }
}

export const copyGradeDivisionTemplate = async (fromTemplate, toTemplate) => {
  // https://stage9.swiftcampus.com/RCGradeMaster1.php?copy=template&From_Template=2&To_Template=2
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.post(
      `${BASE_URL}/RCDivisionMaster1.php?copy=template&From_Template=${fromTemplate}&To_Template=${toTemplate}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while Copying Division templates', err.message) // Handle errors
  }
}

export const submitScholasticDivisions = async (
  template,
  division,
  remarks,
  lowerLimit,
  UpperLimit,
) => {
  // https://stage9.swiftcampus.com/RCDivisionMaster1.php?template_id=10&template_sender=&division=D&template_sender=&remarks=Excellent&lower_limit=40&upper_limit=90&from_template=&to_template=
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.post(
      `${BASE_URL}/RCDivisionMaster1.php?template_id=${template}&template_sender=1&division=${division}&template_sender=1&remarks=${remarks}&lower_limit=${lowerLimit}&upper_limit=${UpperLimit}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while submitting scholastiv Division', err.message) // Handle errors
  }
}

export const editScholasticDivisions = async (
  rdmId,
  template,
  division,
  remarks,
  lowerLimit,
  UpperLimit,
) => {
  // https://stage9.swiftcampus.com/RCEditDivisionMaster1.php?template_id=10&template_sender=&RDM_Id=1&division=A&template_sender=&remarks=Excellent&lower_limit=61&template_sender=&upper_limit=100&template_sender=
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.post(
      `${BASE_URL}/RCEditDivisionMaster1.php?RDM_Id=${rdmId}&template_id=${template}&template_sender=1&division=${division}&template_sender=1&remarks=${remarks}&lower_limit=${lowerLimit}&upper_limit=${UpperLimit}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while editing scholastiv Division', err.message) // Handle errors
  }
}

export const getScholasticValuesByType = async (marksType) => {
  // https://stage9.swiftcampus.com/RCScholasticValueList1.php?Client_Type=NOCHECK&table_body=1&marks_type=ANY%20VALUE
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/RCScholasticValueList1.php?Client_Type=NOCHECK&table_body_new=1&marks_type=${marksType}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting scholastiv values by type', err.message) // Handle errors
  }
}

export const submitScholasticValues = async (marksType, marksValue, sequenceNo) => {
  // https://stage9.swiftcampus.com/RCScholasticValueList1.php?marks_type=GRADE&marks_value=D3&template_sender=&sequence_no=8
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/RCScholasticValueList1.php?marks_type=${marksType}&marks_value=${marksValue}&template_sender=1&sequence_no=${sequenceNo}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while submitting scholastic Values', err.message) // Handle errors
  }
}

export const editScholasticValues = async (svtId, marksType, marksValue, sequenceNo) => {
  // https://stage9.swiftcampus.com/RCScholasticValueList1.php?marks_value=A1&edit_value=value&SVT_Id=1&marks_type=GRADE&sequence_no=1
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/RCScholasticValueList1.php?SVT_Id=${svtId}&marks_type=${marksType}&marks_value=${marksValue}&edit_value=value&sequence_no=${sequenceNo}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while editing scholastic Values', err.message) // Handle errors
  }
}

export const deleteScholasticValues = async (svtId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/RCScholasticValueList1.php?disable=value&SVT_Id=${svtId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while deleting scholastic Values', err.message) // Handle errors
  }
}

export const getCreateCoScholasticGradeLists = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/RCCoScholasticGradeListAPI.php?Client_Type=NOCHECK&get_data=get_grade&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting scholastic grades list', err.message) // Handle errors
  }
}

export const submitCreateCoScholasticGradeLists = async (grade, remarks, rgbValue) => {
  //#6447a9 100#71#169
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    const encodedRgb = encodeURIComponent(rgbValue)
    const encodedGrade = encodeURIComponent(grade)
    const encodedRemarks = encodeURIComponent(remarks)

    return await axios.get(
      `${BASE_URL}/RCCreateCoScholasticGradeList1.php?Grade=${encodedGrade}&grade_remarks=${encodedRemarks}&grade_list_rgb_value=${encodedRgb}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while submitting scholastic grades', err.message) // Handle errors
  }
}

export const editCreateCoScholasticGradeLists = async (csglId, grade, remarks, rgbValue) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    const encodedRgb = encodeURIComponent(rgbValue)
    const encodedGrade = encodeURIComponent(grade)
    const encodedRemarks = encodeURIComponent(remarks)

    return await axios.get(
      `${BASE_URL}/RCEditCoScholasticGradeList1.php?CSGL_Id=${csglId}&grade_name=${encodedGrade}&grade_remarks=${encodedRemarks}&grade_list_rgb_value=${encodedRgb}&schoolCode=${schoolCode}&loginId=${loginId}`,
    )
  } catch (err) {
    console.log('Error while editing scholastic grades', err.message)
  }
}

export const getCoscolasticGroupMaster = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/RCCoscolasticGroup_Control.php?get_data=1&get_group_master_data=1&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting scholastic group master', err.message) // Handle errors
  }
}

export const submitCoscolasticGroupMaster = async (
  groupName,
  groupType,
  gradeColumn,
  sequenceNo,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // RCCoscolasticGroup_Control.php?group_name=Discipline&group_name_insert=insert&group_type=Grade&grade_column_caption=Grade&sequence_no=1
  try {
    return await axios.post(
      `${BASE_URL}/RCCoscolasticGroup_Control.php?group_name=${groupName}&group_name_insert=insert&group_type=${groupType}&grade_column_caption=${gradeColumn}&sequence_no=${sequenceNo}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while Subnitting scholastic group master', err.message) // Handle errors
  }
}

export const editCoscolasticGroupMaster = async (
  groupId,
  groupName,
  groupType,
  gradeColumn,
  sequenceNo,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // RCCoscolasticGroup_Control.php?group_name=Co-Scholastic+Area&group_name_insert=update&coscholastic_group_id=1&group_type=Grade&grade_column_caption=Grade&sequence_no=1
  try {
    return await axios.post(
      `${BASE_URL}/RCCoscolasticGroup_Control.php?coscholastic_group_id=${groupId}&group_name=${groupName}&group_name_insert=update&group_type=${groupType}&grade_column_caption=${gradeColumn}&sequence_no=${sequenceNo}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while editing scholastic group master', err.message) // Handle errors
  }
}

export const getCoscolasticAreaMaster = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/RCCoscolasticGroup_Control.php?get_data=1&get_group_area_master_data=1&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting scholastic Area master', err.message) // Handle errors
  }
}

export const submitCoscolasticAreaMaster = async (groupName, smallName) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // RCCoscolasticGroup_Control.php?group_name=Discipline&group_area_master_insert=insert&group_name_small=Discipline
  try {
    return await axios.post(
      `${BASE_URL}/RCCoscolasticGroup_Control.php?group_name=${groupName}&group_area_master_insert=insert&group_name_small=${smallName}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while Submitting scholastic Area master', err.message) // Handle errors
  }
}

export const editCoscolasticAreaMaster = async (groupId, groupName, smallName) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // RCCoscolasticGroup_Control.php?group_name=Work+Education&group_area_master_insert=update&coscholastic_area_id=1&group_name_small=Work+Education
  try {
    return await axios.post(
      `${BASE_URL}/RCCoscolasticGroup_Control.php?coscholastic_area_id=${groupId}&group_name=${groupName}&group_area_master_insert=update&group_name_small=${smallName}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while editing scholastic Area master', err.message) // Handle errors
  }
}

export const getTeachersRemarksName = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/RCTeachersRemarks_Control.php?get_data=1&get_teachers_remarks_data=1&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Teachers Remarks Name', err.message) // Handle errors
  }
}

export const submitTeachersRemarksName = async (remarkName) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/RCTeachersRemarks_Control.php?reamrks_name=${remarkName}&reamrks_name_insert=insert&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while submitting Teachers Remarks Name', err.message) // Handle errors
  }
}

export const editTeachersRemarksName = async (id, remarkName) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/RCTeachersRemarks_Control.php?teachers_remarks_id=${id}&reamrks_name=${remarkName}&reamrks_name_insert=update&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while editing Teachers Remarks Name', err.message) // Handle errors
  }
}

export const getCoscolasticGroupArea = async (template, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/RCCoscolasticGroup_Control.php?get_data=1&get_group_area_list_data=1&template_id=${template}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Teachers Remarks Name', err.message) // Handle errors
  }
}

export const mapGroupAreaToTerm = async (termId, groupId, areaId, action) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // http://localhost//stageD/RCCoscolasticGroup_Control.php?&map_group_area_term=1&session=2024-2025&class_id=8&term_id=15&group_id=8&area_id=1&action=map
  try {
    return await axios.get(
      `${BASE_URL}/RCCoscolasticGroup_Control.php?map_group_area_term=1&term_id=${termId}&group_id=${groupId}&area_id=${areaId}&action=${action}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Teachers Remarks Name', err.message) // Handle errors
  }
}

export const AddGroupAreaToClass = async (
  className,
  session,
  groupNameId,
  areaName,
  idSequenceNo,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // http://localhost//stageD/RCCoscolasticGroup_Control.phpclass_name=8&school_session=2024-2025&group_name_id=1&group_area_insert=1&area_name%5B%5D=1&id_sequence_no%5B%5D=1&area_name%5B%5D=2&id_sequence_no%5B%5D=1&total_no_of_rows=2&group_area_id=&term_id=15
  const params = new URLSearchParams({
    class_name: className,
    school_session: session,
    group_name_id: groupNameId,
    group_area_insert: 1,
    loginid: loginId,
  })
  areaName.forEach((area) => params.append('area_name[]', area))
  idSequenceNo.forEach((seq) => params.append('id_sequence_no[]', seq))
  try {
    return await axios.get(
      `${BASE_URL}/RCCoscolasticGroup_Control.php?${params.toString()}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while submitting AddGroupAreaToClass', err.message) // Handle errors
  }
}

export const deleteGroupArea = async (areaId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // http://localhost//stageD/RCCoscolasticGroup_Control.php?Client_Type=NOCHECK&delete_area=1&area_id=37
  try {
    return await axios.get(
      `${BASE_URL}/RCCoscolasticGroup_Control.php?Client_Type=NOCHECK&delete_area=1&area_id=${areaId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Teachers Remarks Name', err.message) // Handle errors
  }
}

export const getStudentsListJson = async (classId, secId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // http://localhost//stageD/RCStudentWiseMarksEntry1.php?Client_Type=NOCHECK&get_all_students_by_class_section=1&class_id=4&sec_id=8&session=2024-2025&loginid=swipetouch
  try {
    return await axios.get(
      `${BASE_URL}/RCStudentWiseMarksEntry1.php?Client_Type=NOCHECK&get_all_students_by_class_section=1&class_id=${classId}&sec_id=${secId}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Teachers Remarks Name', err.message) // Handle errors
  }
}
// NEED CHANGES IN STAFFID
export const getStaffPermissionFlag = async (subjectId, secId, classId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const userId = getCookieValue('userId')
  const loginId = getCookieValue('loginId')
  // http://localhost//stageD/StaffPermissions_Controller.php?&permission_for_report_card_new=1&Staff_Id=1&Subject_Id=0&Section_Id=8&class_id=4&Session=2024-2025&permission_name=Marks_Entry&permission_type=View&loginid=swipetouch
  try {
    return await axios.get(
      `${BASE_URL}/StaffPermissions_Controller.php?&permission_for_report_card_new=1&Staff_Id=${userId}&Subject_Id=${subjectId}&Section_Id=${secId}&class_id=${classId}&Session=${session}&permission_name=Marks_Entry&permission_type=View&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Teachers Remarks Name', err.message) // Handle errors
  }
}

export const getStaffPermissionFlagEdit = async (subjectId, secId, classId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const userId = getCookieValue('userId')
  const loginId = getCookieValue('loginId')
  // http://localhost//stageD/StaffPermissions_Controller.php?&permission_for_report_card_new=1&Staff_Id=1&Subject_Id=0&Section_Id=8&class_id=4&Session=2024-2025&permission_name=Marks_Entry&permission_type=View&loginid=swipetouch
  try {
    return await axios.get(
      `${BASE_URL}/StaffPermissions_Controller.php?&permission_for_report_card_new=1&Staff_Id=${userId}&Subject_Id=${subjectId}&Section_Id=${secId}&class_id=${classId}&Session=${session}&permission_name=Marks_Entry&permission_type=Edit&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Teachers Remarks Name', err.message) // Handle errors
  }
}

export const getStudentWiseMarksEntry = async (classId, secId, studentId, session, exam) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // http://localhost//stageD/RCStudentWiseMarksEntry1.php?Client_Type=NOCHECK&get_data=get_subject&Class_Id=4&Section_Id=7&Student_Id=5816&Session=2024-2025&exam_name=88&loginid=swipetouch
  try {
    return await axios.get(
      `${BASE_URL}/RCStudentWiseMarksEntry1.php?Client_Type=NOCHECK&get_data=get_subject&Class_Id=${classId}&Section_Id=${secId}&Student_Id=${studentId}&Session=${session}&exam_name=${exam}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Teachers Remarks Name', err.message) // Handle errors
  }
}

export const submitStudentWiseMarksEntry = async (
  classId,
  secId,
  subjectId,
  session,
  marksData,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  const userId = getCookieValue('userId')

  const enhancedMarks = marksData.map((item) => ({
    ...item,
    School_Id: 1,
    Updated_By: loginId,
  }))

  const formData = {
    save_student_marks: 'save',
    updatemarks: JSON.stringify(enhancedMarks),
    class_id: classId,
    sec_id: secId,
    permission_name: 'Marks_Entry',
    permission_type: 'Edit',
    subject_id: subjectId,
    Staff_Id: userId,
    session: session,
    loginid: loginId,
    schoolid: 1,
    Call_From: 'WEB',
  }

  try {
    return await axios.post(
      `${BASE_URL}/RCStudentWiseMarksEntry1.php?schoolCode=${schoolCode}&loginId=${loginId}`,
      new URLSearchParams(formData),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    )
  } catch (err) {
    console.error('Error submitting marks:', err)
    throw err
  }
}

export const getSubjectsByClassSecId = async (classId, secId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //localhost//stageD/RCSubjectListAPI.php?Client_Type=NOCHECK&get_data=get_subject&Class_Id=4&Section_Id=7&loginid=swipetouch&Session=2024-2025
  try {
    return await axios.get(
      `${BASE_URL}/RCSubjectListAPI.php?Client_Type=NOCHECK&get_data=get_subject&Class_Id=${classId}&Section_Id=${secId}&Session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Teachers Remarks Name', err.message) // Handle errors
  }
}

export const getExamsBySubjectsClassSecId = async (ttl_id, classId, secId, subjectId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //http://localhost//stageD/RCReportCardApis.php?Client_Type=NOCHECK&get_data=get_exam_name&TTL_Id=23&Class_Id=4&Section_Id=7&Subject_Id=21&loginid=swipetouch
  try {
    return await axios.get(
      `${BASE_URL}/RCReportCardApis.php?Client_Type=NOCHECK&get_data=get_exam_name&TTL_Id=${ttl_id}&Class_Id=${classId}&Section_Id=${secId}&Subject_Id=${subjectId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Teachers Remarks Name', err.message) // Handle errors
  }
}

export const getMarksType = async (classId, subjectId, examId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //http://localhost//stageD/RCMarksTypeApi.php?Client_Type=NOCHECK&get_data=marks_type&Class_Id=4&Subject=21&Exam_Id=90&session=2024-2025&loginid=swipetouch
  try {
    return await axios.get(
      `${BASE_URL}/RCMarksTypeApi.php?Client_Type=NOCHECK&get_data=marks_type&Class_Id=${classId}&Subject=${subjectId}&Exam_Id=${examId}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Teachers Remarks Name', err.message) // Handle errors
  }
}

export const getSubjectWiseMarksEntry = async (classId, secId, subjectId, session, exam) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //http://localhost//stageD/RCSubjectWiseMarksEntry1.php?Client_Type=NOCHECK&get_all_students_by_class_section=1&class_id=4&sec_id=7&subject=21&session=2024-2025&exam_name=88&loginid=swipetouch
  try {
    return await axios.get(
      `${BASE_URL}/RCSubjectWiseMarksEntry1.php?Client_Type=NOCHECK&get_all_students_by_class_section=1&class_id=${classId}&sec_id=${secId}&subject=${subjectId}&session=${session}&exam_name=${exam}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Teachers Remarks Name', err.message) // Handle errors
  }
}

export const submitSubjectWiseMarksEntry = async (
  lockStatus,
  session,
  exam,
  subjectId,
  classId,
  secId,
  marksData,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  const enhancedMarks = marksData.map((item) => ({
    ...item,
    School_Id: 1,
    Updated_By: loginId,
  }))

  const formData = {
    save_student_marks: 'save',
    updatemarks: JSON.stringify(enhancedMarks),
    lock_status: lockStatus,
    Session: session,
    TEL_Id: exam,
    Subject_Id: subjectId,
    Class_Id: classId,
    Section_Id: secId,
    loginid: loginId,
    schoolid: 1,
    Call_From: 'WEB',
  }

  try {
    return await axios.post(
      `${BASE_URL}/RCStudentWiseMarksEntry1.php`,
      new URLSearchParams(formData),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    )
  } catch (err) {
    console.error('Error submitting subject marks:', err)
    throw err
  }
}

export const getStudentGradeEntry = async (classId, secId, term, studentId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  const userId = getCookieValue('userId')
  //http://localhost//stageD/RCCoscholasticStudentGradeEntry1.php?Client_Type=NOCHECK&get_all_areas_by_class_section=1&class_id=4&sec_id=8&session=2024-2025&term=22&student_id=6076&permission_type=View&permission_name=Marks_Entry&Staff_Id=1&loginid=swipetouch
  try {
    return await axios.get(
      `${BASE_URL}/RCCoscholasticStudentGradeEntry1.php?Client_Type=NOCHECK&get_all_areas_by_class_section=1&class_id=${classId}&sec_id=${secId}&term=${term}&student_id=${studentId}&session=${session}&permission_type=View&permission_name=Marks_Entry&Staff_Id=${userId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Teachers Remarks Name', err.message) // Handle errors
  }
}

export const submitStudentGradeEntry = async (session, classId, secId, updategrades) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  const userId = getCookieValue('userId')

  const formData = {
    save_student_marks: 'save',
    updategrades: JSON.stringify(updategrades),
    Staff_Id: userId,
    session: session,
    permission_type: 'Add',
    permission_name: 'Marks_Entry',
    class_id: classId,
    class_sec_id: secId,
    schoolid: 1,
    loginid: loginId,
  }

  try {
    return await axios.post(
      `${BASE_URL}/RCCoscholasticStudentGradeEntry1.php?schoolCode=${schoolCode}&loginId=${loginId}`,
      new URLSearchParams(formData),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    )
  } catch (err) {
    console.error('Error submitting subject marks:', err)
    throw err
  }
}

export const getAreaTypeByClassSecId = async (classId, secId, session) => {
  const loginId = getCookieValue('loginId')
  const schoolCode = getCookieValue('schoolCode')
  //http://localhost/stageD/RCCoscolasticGroup_Control.php?get_data=1&get_group_area_option_data=1&s_class=4&class_section=8&session=2024-2025
  try {
    return await axios.get(
      `${BASE_URL}/RCCoscolasticGroup_Control.php?get_data=1&get_group_area_option_data=1&s_class=${classId}&class_section=${secId}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Teachers Remarks Name', err.message) // Handle errors
  }
}

export const getAreaNameByAreaType = async (areaTypeId) => {
  const loginId = getCookieValue('loginId')
  const schoolCode = getCookieValue('schoolCode')
  //http://localhost/stageD/RCCoscolasticGroup_Control.php?get_data=1&get_group_area_subject_option_data=1&area_type_id=10
  try {
    return await axios.get(
      `${BASE_URL}/RCCoscolasticGroup_Control.php?get_data=1&get_group_area_subject_option_data=1&area_type_id=${areaTypeId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Teachers Remarks Name', err.message) // Handle errors
  }
}

export const getTemplateGradeEntry = async (classId, secId, session, term, areaType, areaName) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  const userId = getCookieValue('userId')
  const schoolId = getCookieValue('SCHOOLID')
  //http://http://localhost/stageD/RCCoscholasticTemplateGradeEntry1.php?Client_Type=NOCHECK&get_all_students_by_class_section=1&class_id=4&sec_id=7&session=2024-2025&term=22&area_type=10&area=1&permission_type=View&permission_name=Marks_Entry&Staff_Id=1
  try {
    return await axios.get(
      `${BASE_URL}/RCCoscholasticTemplateGradeEntry1.php?Client_Type=NOCHECK&get_all_students_by_class_section_new=1&class_id=${classId}&sec_id=${secId}&session=${session}&term=${term}&area_type=${areaType}&area=${areaName}&permission_type=View&permission_name=Marks_Entry&Staff_Id=${userId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Teachers Remarks Name', err.message) // Handle errors
  }
}

export const submitTemplateGradeEntry = async (session, classId, secId, updategrades) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  const userId = getCookieValue('userId')

  const formData = {
    save_student_marks: 'save',
    updategrades: JSON.stringify(updategrades),
    Staff_Id: userId,
    session: session,
    permission_type: 'Add',
    permission_name: 'Marks_Entry',
    class_id: classId,
    class_sec_id: secId,
  }

  try {
    return await axios.post(
      `${BASE_URL}/RCCoscholasticTemplateGradeEntry1.php?schoolCode=${schoolCode}&loginId=${loginId}`,
      new URLSearchParams(formData),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    )
  } catch (err) {
    console.error('Error submitting subject marks:', err)
    throw err
  }
}

export const getMarksAdjustmentEntry = async (classId, secId, subjectId, session, exam) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //http://localhost//stageD/RCMarksAdjustment1.php?Client_Type=NOCHECK&get_all_students_by_class_section=1&class_id=4&sec_id=7&subject=21&session=2024-2025&exam_name=88&loginid=swipetouch
  try {
    return await axios.get(
      `${BASE_URL}/RCMarksAdjustment1.php?Client_Type=NOCHECK&get_all_students_by_class_section=1&class_id=${classId}&sec_id=${secId}&subject=${subjectId}&session=${session}&exam_name=${exam}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Teachers Remarks Name', err.message) // Handle errors
  }
}

export const submitMarksAdjustmentEntry = async (
  lockStatus,
  session,
  exam,
  subjectId,
  classId,
  secId,
  marksData,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  const enhancedMarks = marksData.map((item) => ({
    ...item,
    School_Id: 1,
    Updated_By: loginId,
  }))

  const formData = {
    save_student_marks: 'save',
    updatemarks: JSON.stringify(enhancedMarks),
    lock_status: lockStatus,
    Session: session,
    TEL_Id: exam,
    Subject_Id: subjectId,
    Class_Id: classId,
    Section_Id: secId,
    loginid: loginId,
    schoolid: 1,
    Call_From: 'WEB',
  }

  try {
    return await axios.post(
      `${BASE_URL}/RCMarksAdjustment1.php?schoolCode=${schoolCode}&loginId=${loginId}`,
      new URLSearchParams(formData),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    )
  } catch (err) {
    console.error('Error submitting subject marks:', err)
    throw err
  }
}

export const getExamWiseAttendanceEntry = async (classId, secId, session, termId, exam) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  const userId = getCookieValue('userId')
  //http://localhost//stageD/RCExamWiseAttendanceEntry1.php?Client_Type=NOCHECK&get_all_students_by_class_section=1&class_id=4&sec_id=7&session=2024-2025&term_id=22&exam_id=88&loginid=swipetouch&schoolid=1&permission_type=View&permission_name=Marks_Entry&Staff_Id=1
  try {
    return await axios.get(
      `${BASE_URL}/RCExamWiseAttendanceEntry1.php?Client_Type=NOCHECK&get_all_students_by_class_section=1&class_id=${classId}&sec_id=${secId}&session=${session}&term_id=${termId}&exam_id=${exam}&schoolCode=${schoolCode}&loginId=${loginId}&schoolid=1&permission_type=View&permission_name=Marks_Entry&Staff_Id=${userId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Teachers Remarks Name', err.message) // Handle errors
  }
}

export const submitExamWiseAttendanceEntry = async (
  classId,
  secId,
  session,
  exam,
  term,
  workingDays,
  updateRemarks,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  const userId = getCookieValue('userId')

  const formData = {
    Client_Type: 'NOCHECK',
    save_student_marks: 'save',
    Class_Id: classId,
    Section_Id: secId,
    session: session,
    exam_id: exam,
    term_id: term,
    working_days: workingDays,
    updateremarks: JSON.stringify(updateRemarks),
    loginid: loginId,
    schoolid: 1,
    permission_name: 'Marks_Entry',
    permission_type: 'Add',
    Staff_Id: userId,
  }

  try {
    return await axios.post(
      `${BASE_URL}/RCExamWiseAttendanceEntry1.php?schoolCode=${schoolCode}&loginId=${loginId}`,
      new URLSearchParams(formData),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    )
  } catch (err) {
    console.error('Error submitting Exam Wise marks:', err)
    throw err
  }
}

export const checkMarksEntryLock = async (classId, secId, subjectId, session, termId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  const userId = getCookieValue('userId')
  //http://localhost//stageD/RCSubjectWiseMarksImport1.php?&marks_locking_check=1&class_id=4&sec_id=7&subject=21&session=2024-2025&term_id=22&loginid=swipetouch
  try {
    return await axios.get(
      `${BASE_URL}/RCSubjectWiseMarksImport1.php?&marks_locking_check=1&class_id=${classId}&sec_id=${secId}&subject=${subjectId}&session=${session}&term_id=${termId}&loginid=${loginId}&loginId=${loginId}&schoolCode=${schoolCode}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Teachers Remarks Name', err.message) // Handle errors
  }
}
export const importSubjectWiseMarksExcel = async (file) => {
  const loginId = getCookieValue('loginId')
  const schoolCode = getCookieValue('schoolCode')

  const formData = new FormData()
  formData.append('import_marks_excel', '1')
  formData.append('import_file', file)
  formData.append('loginid', loginId)
  formData.append('Call_From', 'WEB')

  try {
    const response = await axios.post(
      `${BASE_URL}/RCSubjectWiseMarksImport1.php?schoolCode=${schoolCode}&loginId=${loginId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    return response
  } catch (err) {
    console.error('Error while importing Excel:', err.message)
    throw err
  }
}
export const importMarksImportExcel = async (file) => {
  const loginId = getCookieValue('loginId')
  const schoolCode = getCookieValue('schoolCode')

  const formData = new FormData()
  formData.append('importMarksExcel', '1')
  formData.append('import_file', file)
  formData.append('loginid', loginId)
  formData.append('schoolCode', schoolCode)
  formData.append('Call_From', 'WEB')

  try {
    const response = await axios.post(
      `${BASE_URL}/api-controller/holistic-progress-report/getHolisticReportData.php`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    return response
  } catch (err) {
    console.error('Error while importing Excel:', err.message)
    throw err
  }
}

export const getExamAttendanceEntry = async (
  classId,
  secId,
  session,
  termId,
  systemAttendance,
  fdate,
  tdate,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  const userId = getCookieValue('userId')
  //http://localhost//stageD/RCExamAttendanceEntry1.php?Client_Type=NOCHECK&get_all_students_by_class_section=1&class_id=4&sec_id=7&session=2024-2025&term_id=22&system_attendance=1&fdate=16/06/2025&tdate=29/05/2025&loginid=swipetouch&schoolid=1&permission_type=View&permission_name=Marks_Entry&Staff_Id=1
  try {
    return await axios.get(
      `${BASE_URL}/RCExamAttendanceEntry1.php?Client_Type=NOCHECK&get_all_students_by_class_section=1&class_id=${classId}&sec_id=${secId}&session=${session}&term_id=${termId}&system_attendance=${systemAttendance}&fdate=${fdate}&tdate=${tdate}&schoolCode=${schoolCode}&loginId=${loginId}&permission_type=View&permission_name=Marks_Entry&Staff_Id=${userId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting Teachers Remarks Name', err.message) // Handle errors
  }
}

export const submitExamAttendanceEntry = async (
  classId,
  secId,
  session,
  term,
  workingDays,
  updateRemarks,
  rc_term_files,
  rc_final_files,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  const userId = getCookieValue('userId')

  const formData = new FormData()

  formData.append('Client_Type', 'NOCHECK')
  formData.append('save_student_marks', 'save')
  formData.append('Class_Id', classId)
  formData.append('Section_Id', secId)
  formData.append('session', session)
  formData.append('term_id', term)
  formData.append('working_days', workingDays)
  formData.append('updateremarks', JSON.stringify(updateRemarks))
  formData.append('loginid', loginId)
  formData.append('schoolid', '1')
  formData.append('permission_type', 'Add')
  formData.append('permission_name', 'Marks_Entry')
  formData.append('Staff_Id', userId)

  rc_term_files.forEach((file, index) => {
    if (file) {
      formData.append(`rc_term_file${index + 1}`, file)
    }
  })

  rc_final_files.forEach((file, index) => {
    if (file) {
      formData.append(`rc_final_file${index + 1}`, file)
    }
  })

  try {
    return await axios.post(`${BASE_URL}/RCExamAttendanceEntry1.php?schoolCode=${schoolCode}&loginId=${loginId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (err) {
    console.error('Error submitting Exam marks:', err)
    throw err
  }
}

export const getRankWiseReport = async (formData) => {
  try {
    return await axios.post(`${BASE_URL}/RCGenerate_Rank_Data.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`, formData) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting rank reports', err.message) // Handle errors
  }
}
export const getExamAnalysisReport = async (formData) => {
  try {
    return await axios.post(
      `${BASE_URL}/RCGenerateReportCardSubjectWise1.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
      formData,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting exam analysis report', err.message) // Handle errors
  }
}

export const getSubjectsByClassSessionSection = async (class_id, section, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/RCSubjectListAPI.php?Client_Type=NOCHECK&get_data=get_subject&Class_Id=${class_id}&Section_Id=${section}&loginid=Swipetouch_Admin&Session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting ssubjects', err.message) // Handle errors
  }
}

export const getUpdatedMarkLog = async (formData) => {
  try {
    return await axios.post(`${BASE_URL}/RCUpdatedMarksLog1.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`, formData) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting updated mark log', err.message) // Handle errors
  }
}
export const getUpdatedMarkLogOtherData = async (formData) => {
  try {
    return await axios.post(`${BASE_URL}/RCUpdatedMarksLog1.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`, formData) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting updated mark log other data', err.message) // Handle errors
  }
}
export const getStudentDetailsListForExamWiseReportCard = async (
  session,
  class_id,
  sec_id,
  term_id,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.post(
      `${BASE_URL}/RCindividualExam1.php?Client_Type=NOCHECK&get_all_students_by_class_section_new=1&session=${session}&class_id=${class_id}&sec_id=${sec_id}&term_id=${term_id}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting getStudentDetailsListForExamWiseReportCard', err.message) // Handle errors
  }
}
export const getExamsetsBySession = async (session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.post(
      `${BASE_URL}/RCMarksEntryStatus1.php?Client_Type=NOCHECK&get_exams_sets_by_session=1&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting getStudentDetailsListForExamWiseReportCard', err.message) // Handle errors
  }
}
export const getTemplatesBySession = async (session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.post(
      `${BASE_URL}/RCAllClassReportsConfig1.php?Client_Type=NOCHECK&get_template_list=1&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting getStudentDetailsListForExamWiseReportCard', err.message) // Handle errors
  }
}
export const getExamSetCOnfigs = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.post(
      `${BASE_URL}/RCAllClassReportsConfig1.php?Get_Table_Data=1&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting getExamSetCOnfigs', err.message) // Handle errors
  }
}
export const deleteExamSetConfig = async (ESM_Id) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.post(
      `${BASE_URL}/RCAllClassReportsConfig1.php?Delete_Data=1&ESM_Id=${ESM_Id}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting deleting exam set', err.message) // Handle errors
  }
}
export const createExamSetConfig = async (formdata) => {
  try {
    return await axios.post(`${BASE_URL}/RCAllClassReportsConfig1.php`, formdata) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while creating new exam set', err.message) // Handle errors
  }
}
export const getExamGroupNames = async (ESM_Id) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // http://localhost/stageD/RC_HPC_ExamGroup1.php?Client_Type=NOCHECK&get_exam_group_names=1&loginid=undefined
  try {
    return await axios.post(
      `${BASE_URL}/RC_HPC_ExamGroup1.php?Client_Type=NOCHECK&get_exam_group_names=1&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting deleting exam set', err.message) // Handle errors
  }
}

export const getTestGroups = async (classId, secId, session, stream) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //http://localhost/stageD/RC_HPC_ExamGroup1.php?Client_Type=NOCHECK&table_body_new=1&class_id=4&section_id=7&session=2024-2025&stream=GENERAL&loginid=swipetouch
  try {
    return await axios.post(
      `${BASE_URL}/RC_HPC_ExamGroup1.php?Client_Type=NOCHECK&table_body_new=1&class_id=${classId}&section_id=${secId}&session=${session}&stream=${stream}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while get Test group', err.message) // Handle errors
  }
}

export const submitHolisticTestGroup = async (
  classId,
  secId,
  session,
  stream,
  subjectId,
  term,
  exam,
  examGroup,
  seqNo,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  const formData = new FormData()
  formData.append('class_id', classId)
  formData.append('section_id', secId)
  formData.append('session', session)
  formData.append('stream', stream)
  formData.append('subject_id', subjectId)
  formData.append('term_id', term)
  formData.append('exam_id', exam)
  formData.append('exam_group', examGroup)
  formData.append('sequence_no', seqNo)
  formData.append('template_sender', '1')
  formData.append('schoolCode', schoolCode)
  formData.append('loginId', loginId)

  try {
    return await axios.post(`${BASE_URL}/RC_HPC_ExamGroup1.php`, formData)
  } catch (err) {
    console.log('Error while getting Test group:', err.message)
  }
}

export const editHolisticTestGroup = async (
  classId,
  secId,
  session,
  stream,
  subjectId,
  term,
  exam,
  examGroup,
  seqNo,
  hegId,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // session=2024-2025&class_id=4&section_id=7&stream=GENERAL&subject_id=1&term_id=22&exam_id=88&exam_group=JOHNNY+JOHNNY&sequence_no=11&template_sender=&heg_id=38&loginid=swipetouch&schoolid=1
  const formData = new FormData()
  formData.append('class_id', classId)
  formData.append('section_id', secId)
  formData.append('session', session)
  formData.append('stream', stream)
  formData.append('subject_id', subjectId)
  formData.append('term_id', term)
  formData.append('exam_id', exam)
  formData.append('exam_group', examGroup)
  formData.append('sequence_no', seqNo)
  formData.append('template_sender', '1')
  formData.append('heg_id', hegId)
  formData.append('schoolCode', schoolCode)
  formData.append('loginId', loginId)

  try {
    return await axios.post(`${BASE_URL}/RC_HPC_ExamGroupEdit1.php`, formData)
  } catch (err) {
    console.log('Error while getting Test group:', err.message)
  }
}

export const DeleteTestGroup = async (HEGId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // http://localhost/stageD/RC_HPC_ExamGroup1.php?Client_Type=NOCHECK&disable_examgroup=1&HEG_Id=41&loginid=swipetouch
  try {
    return await axios.post(
      `${BASE_URL}/RC_HPC_ExamGroup1.php?Client_Type=NOCHECK&disable_examgroup=1&HEG_Id=${HEGId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while get Test group', err.message) // Handle errors
  }
}
export const selectTestGroup = async (session, classId, secId, stream, subjectId, examId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // http://localhost//stageD/RC_HPC_ExamList1.php?Client_Type=NOCHECK&get_exam_groups=1&Session=2024-2025&Class_Id=4&Section_Id=7&Stream=GENERAL&Subject_Id=21&Exam_Id=88&loginid=swipetouch
  try {
    return await axios.post(
      `${BASE_URL}/RC_HPC_ExamList1.php?Client_Type=NOCHECK&get_exam_groups=1&Session=${session}&Class_Id=${classId}&Section_Id=${secId}&Stream=${stream}&Subject_Id=${subjectId}&Exam_Id=${examId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while get Test group', err.message) // Handle errors
  }
}

export const selectTestName = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // http://localhost//stageD/RC_HPC_ExamList1.php?Client_Type=NOCHECK&get_exam_names=1&loginid=swipetouch
  try {
    return await axios.post(
      `${BASE_URL}/RC_HPC_ExamList1.php?Client_Type=NOCHECK&get_exam_names=1&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while get Test group', err.message) // Handle errors
  }
}

export const getCreateTest = async (examGroupId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // http://localhost//stageD/RC_HPC_ExamList1.php?Client_Type=NOCHECK&table_body=1&exam_group_id=29&loginid=swipetouch
  try {
    return await axios.post(
      `${BASE_URL}/RC_HPC_ExamList1.php?Client_Type=NOCHECK&table_body_new=1&exam_group_id=${examGroupId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while get Test group', err.message) // Handle errors
  }
}

export const submitCreateTest = async (
  classId,
  secId,
  session,
  stream,
  subjectId,
  term,
  exam,
  examGroupId,
  examGroupType,
  examGroupName,
  seqNo,
  marksType,
  testMarks,
  convMarks,
  passMarks,
  precision,
) => {
  // http://localhost//stageD/RC_HPC_ExamList1.php?session=2024-2025&class_id=4&section_id=7&stream=GENERAL&subject_id=21&term_id=22&exam_id=88&exam_group_id=29&exam_type=SUMMARY&exam_name=ACCENT&sequence_no=1&marks_type[0]=NUMBER&marks[0][0]=6&marks[1][0]=6&marks[2][0]=0&precision[0]=0&template_sender=&loginid=swipetouch&schoolid=1

  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  const formData = new FormData()
  formData.append('class_id', classId)
  formData.append('section_id', secId)
  formData.append('session', session)
  formData.append('stream', stream)
  formData.append('subject_id', subjectId)
  formData.append('term_id', term)
  formData.append('exam_id', exam)
  formData.append('exam_group_id', examGroupId)
  formData.append('exam_type', examGroupType)
  formData.append('exam_name', examGroupName)
  formData.append('sequence_no', seqNo)
  formData.append('marks_type', marksType)
  formData.append('test_marks', testMarks)
  formData.append('converted_test_marks', convMarks)
  formData.append('pass_marks', passMarks)
  formData.append('precision', precision)
  formData.append('template_sender_new', '1')
  formData.append('schoolid', '1')
  formData.append('schoolCode', schoolCode)
  formData.append('loginId', loginId)

  try {
    return await axios.post(`${BASE_URL}/RC_HPC_ExamList1.php`, formData)
  } catch (err) {
    console.log('Error while getting Test :', err.message)
  }
}

export const editCreateTest = async (
  classId,
  secId,
  session,
  stream,
  subjectId,
  term,
  exam,
  examGroupId,
  examGroupType,
  examGroupName,
  seqNo,
  marksType,
  testMarks,
  convMarks,
  passMarks,
  precision,
  helId,
) => {
  //  http://localhost//stageD/RC_HPC_ExamListEdit1.php?session=2024-2025&class_id=4&section_id=7&stream=GENERAL&subject_id=21&term_id=22&exam_id=88&exam_group_id=29&exam_type=EXAM&exam_name=compares+and+analyses+attributes+of+two+and+three+–+dimensional+shapes+and+develops+vocabulary+to+describe+their+attributes/+properties.&sequence_no=1&marks_type[0]=NUMBER&marks[0][0]=5&marks[1][0]=5&marks[2][0]=0&precision[0]=0&template_sender=&hel_id=63&loginid=swipetouch&schoolid=1
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  const formData = new FormData()
  formData.append('session', session)
  formData.append('class_id', classId)
  formData.append('section_id', secId)
  formData.append('stream', stream)
  formData.append('subject_id', subjectId)
  formData.append('term_id', term)
  formData.append('exam_id', exam)
  formData.append('exam_group_id', examGroupId)
  formData.append('exam_type', examGroupType)
  formData.append('exam_name', examGroupName)
  formData.append('sequence_no', seqNo)
  formData.append('marks_type', marksType)
  formData.append('test_marks', testMarks)
  formData.append('converted_test_marks', convMarks)
  formData.append('pass_marks', passMarks)
  formData.append('precision', precision)
  formData.append('template_sender_new', '1')
  formData.append('hel_id', helId)
  formData.append('schoolid', '1')
  formData.append('schoolCode', schoolCode)
  formData.append('loginId', loginId)

  try {
    return await axios.post(`${BASE_URL}/RC_HPC_ExamListEdit1.php`, formData)
  } catch (err) {
    console.log('Error while getting Test :', err.message)
  }
}

export const DeleteCreateTest = async (helId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // http://localhost//stageD/RC_HPC_ExamList1.php?Client_Type=NOCHECK&disable_exam=1&HEL_Id=103&loginid=swipetouch

  try {
    return await axios.post(
      `${BASE_URL}/RC_HPC_ExamList1.php?Client_Type=NOCHECK&disable_exam=1&HEL_Id=${helId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while get Test group', err.message) // Handle errors
  }
}

export const getHpcExams = async (session, classId, secId, stream, subjectId, examId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  // http://localhost//stageD/RC_HPC_MarksProcess1.php?Client_Type=NOCHECK&get_hpc_exams=1&Session=2024-2025&Class_Id=4&Section_Id=7&Subject_Id=21&Stream=GENERAL&Exam_Id=88&loginid=swipetouch
  try {
    return await axios.post(
      `${BASE_URL}/RC_HPC_MarksProcess1.php?Client_Type=NOCHECK&get_hpc_exams=1&Session=${session}&Class_Id=${classId}&Section_Id=${secId}&Stream=${stream}&Subject_Id=${subjectId}&Exam_Id=${examId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while get Test group', err.message) // Handle errors
  }
}

export const submitHPCMarksProcess = async (formData) => {
  // http://localhost//stageD/RC_HPC_MarksProcess1.php?session=2024-2025&class_id=4&section_id=7&stream=GENERAL&subject_id=21&term_id=22&exam_id=88&from_exam_type=EXAM&from_exam_groups[]=29&from_exams[]=63&from_exams[]=64&from_exams[]=104&from_exam_groups[]=61&to_exam_type=HPR&to_exam=63&formula=AVG&best_count=0&process_marks=1&Call_From=WEB
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  const fd = new FormData()

  fd.append('session', formData.session)
  fd.append('class_id', formData.class)
  fd.append('section_id', formData.section)
  fd.append('stream', formData.stream)
  fd.append('subject_id', formData.subject)
  fd.append('term_id', formData.term)
  fd.append('exam_id', formData.exam)

  fd.append('from_exam_type', formData.fromExamType)
  fd.append('to_exam_type', formData.toExamType)
  fd.append('to_exam', formData.toExamId)
  fd.append('formula', formData.formula)
  fd.append('best_count', formData.bestCount)

  formData.selectedExams.forEach((examId) => {
    fd.append('from_exams[]', examId)
  })

  formData.selectedGroups.forEach((groupId) => {
    fd.append('from_exam_groups[]', groupId)
  })

  fd.append('process_marks', '1')
  fd.append('Call_From', 'WEB')
  fd.append('loginid', loginId)
  fd.append('schoolCode', schoolCode)

  try {
    const response = await axios.post(
      `${BASE_URL}/RC_HPC_MarksProcess1.php`,
      fd,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    return response
  } catch (err) {
    console.error('Error submitting marks:', err)
    throw err
  }
}

export const getTestsByTestGroup = async (examGroupId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //http://localhost//stageD/RC_HPC_MarksEntry1.php?Client_Type=NOCHECK&get_exam_list=1&exam_group_id=29&loginid=swipetouch
  try {
    return await axios.post(
      `${BASE_URL}/RC_HPC_MarksEntry1.php?Client_Type=NOCHECK&get_exam_list=1&exam_group_id=${examGroupId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while get Test group', err.message) // Handle errors
  }
}

export const getMarksTypeByTest = async (testId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //http://localhost//stageD/RC_HPC_MarksEntry1.php?Client_Type=NOCHECK&get_marks_type=1&Exam_Id=65&loginid=swipetouch
  try {
    return await axios.post(
      `${BASE_URL}/RC_HPC_MarksEntry1.php?Client_Type=NOCHECK&get_marks_type=1&Exam_Id=${testId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while get Test group', err.message) // Handle errors
  }
}

export const getHolisticMarksEntry = async (
  classId,
  secId,
  session,
  subjectId,
  examName,
  examId,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  //http://localhost//stageD/RC_HPC_MarksEntry1.php?Client_Type=NOCHECK&get_all_students_by_class_section=1&class_id=4&sec_id=7&session=2024-2025&Subject_Id=21&exam_name=88&hpc_exam_id=65&loginid=swipetouch
  try {
    return await axios.post(
      `${BASE_URL}/RC_HPC_MarksEntry1.php?Client_Type=NOCHECK&get_all_students_by_class_section=1&class_id=${classId}&sec_id=${secId}&session=${session}&Subject_Id=${subjectId}&exam_name=${examName}&hpc_exam_id=${examId}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while get Test group', err.message) // Handle errors
  }
}

export const submitHPCMarksEntry = async (marksData, lockStatus, testName) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  const enhancedMarks = marksData.map((item) => ({
    ...item,
    School_Id: '1',
    Updated_By: loginId,
  }))

  const formData = {
    save_student_marks: 'save',
    updatemarks: JSON.stringify(enhancedMarks),
    lock_status: lockStatus,
    hpc_exam_id: testName,
    loginid: loginId,
    schoolCode: schoolCode,
  }

  try {
    return await axios.post(
      `${BASE_URL}/RCStudentWiseMarksEntry1.php`,
      new URLSearchParams(formData),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    )
  } catch (err) {
    console.error('Error submitting subject marks:', err)
    throw err
  }
}
export const createNewTerm = async (query) => {
  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateTermList1.php?template_sender_new=1&${query}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while creating new term', err.message) // Handle errors
  }
}
export const getTermDataById = async (term_id) => {
  try {
    return await axios.get(
      `${BASE_URL}/RCCoScholasticTermApi.php?Client_Type=NOCHECK&get_data=get_term_by_id&term_id=${term_id}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while creating new term', err.message) // Handle errors
  }
}
export const copyTermTemplate = async (From_session, To_session, From_Template, To_Template) => {
  try {
    return await axios.get(
      `${BASE_URL}/RCTemplateTermList1.php?copy_terms_new=1&From_session=${From_session}&To_session=${To_session}&From_Template=${From_Template}&To_Template=${To_Template}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while creating copying term', err.message) // Handle errors
  }
}
export const updateTermTemplate = async (querry) => {
  try {
    return await axios.get(
      `${BASE_URL}/RCEditTemplateTermList1.php?template_update_new=1&${querry}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while updating term', err.message) // Handle errors
  }
}
export const getHolisticCards = async (classId, sectionId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/holistic-progress-report/getHolisticReportData.php?schoolCode=${schoolCode}&loginId=${loginId}&getHolisticStudentsCards=1&classId=${classId}&sectionId=${sectionId}&session=${session}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting holistic cards', err.message) // Handle errors
  }
}
export const getMarkEntryLocks = async (testgroup) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/holistic-progress-report/getHolisticReportData.php?schoolCode=${schoolCode}&loginId=${loginId}&getAllMarksEntryLocks=1&testgroup=${testgroup}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting holistic cards', err.message) // Handle errors
  }
}
export const updateMarkEntryLocks = async (lockStatus, helId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/holistic-progress-report/getHolisticReportData.php?schoolCode=${schoolCode}&loginId=${loginId}&UpdateMarksEntryLockStatus=1&helId=${helId}&lockStatus=${lockStatus}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting holistic cards', err.message) // Handle errors
  }
}
export const getTermTableData = async (session, templateId) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/holistic-progress-report/getHolisticReportData.php?schoolCode=${schoolCode}&loginId=${loginId}&getHpcTemplateTermList=1&session=${session}&templateId=${templateId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while geting holistic term tabledata', err.message) // Handle errors
  }
}

export const copyTemplate = async (From_session, To_session, From_Template, To_Template) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/RC_HPC_TemplateTermList1.php?copy_terms_new=1&From_session=${From_session}&To_session=${To_session}&From_Template=${From_Template}&To_Template=${To_Template}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while copying holistic term', err.message) // Handle errors
  }
}